import type { Ctx } from "../types";
import { Action } from "gg-wf-scripts";
import { toast } from "../toast";

export const sign_out: Action<Ctx> = async ({ sb }, _data, _params) => {
  const { error } = await sb.auth.signOut();
  if (error) {
    toast({ variant: "error", text: "Sign out failed. Try again" });
    return { ok: false, error };
  }
  window.location.href = "/";
  return { ok: true };
};
